<template>
<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
  <g data-name="menu" transform="translate(3 4)">
    <rect width="20" height="2" rx="1" fill="currentColor"/>
    <rect width="20" height="2" rx="1" transform="translate(0 7.8)" fill="currentColor"/>
    <rect width="20" height="2" rx="1" transform="translate(0 15.6)" fill="currentColor"/>
  </g>
</svg>
</template>
